import { environment } from '../../environments/environment';

export var GLOBAL = {
  url: environment.url
};
